export const API_BASE_URL = 'https://dev.api.beaive.com';
// export const WEBHOOK_URL = 'https://webhook.site/e5316153-5c94-4322-87c3-d07cfbb54e59';

// Sabai Health Webhook
export const WEBHOOK_URL = 'https://sandbox.sabaihealth.com/webhook/scan-ack';